module.exports = __webpack_public_path__ + "a313f67cf3413a6481f47962b9c92028.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/news/img1.jpg
// module id = 324
// module chunks = 0